export default __webpack_public_path__ + "static/media/uni_icon.37545787.svg";